// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarEmpreendimentoService } from "../../../services/atualizarEmpreendimentoService";

// --------------------- Import Interface ---------------------
import { Empreendimento } from "../../../interfaces/Empreendimento";

export const useAtualizarEmpreendimento = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const resetError = () => setError(null);

  const atualizarEmpreendimento = async (
    empreendId: number | undefined,
    valuesEmp: Empreendimento
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const atualizarEmp = await atualizarEmpreendimentoService(
        empreendId,
        valuesEmp
      );

      if (atualizarEmp) {
        setSuccess("Empreendimento atualizado com sucesso!");
      } else {
        setError("Não foi possível atualizar o empreendimento!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    atualizarEmpreendimento,
    isLoading,
    isSuccess,
    error,
    success,
    resetError,
  };
};
